  import { Component, OnInit, Input } from '@angular/core';
  import { httpService } from '../service/servicio';
  import { ToastsManager } from 'ng2-toastr/ng2-toastr';
  import { ViewContainerRef } from '@angular/core';
  import { AppComponent } from '../app.component';


@Component({
  selector: 'app-datoscclientes',
  templateUrl: './datoscclientes.component.html',
  styleUrls: ['./datoscclientes.component.css']
})
export class DatoscclientesComponent  {

      constructor(public http:httpService, public app: AppComponent, public toastr: ToastsManager, vcr: ViewContainerRef) {

          this.toastr.setRootViewContainerRef(app.vcr);

          if (this.http.clienteGrabar.Id == 0)  this.tituloCliente = "Nuevo Cliente";
          this.http.sw.mostrarClientes = false;

       }


      @Input() clientes:any;

      tituloCliente:string = 'Editando Cliente número: ' + this.http.clienteGrabar.Id;

      clienteactual:any;
      posicionactual:any;

      loaded:boolean = false;
      cloaded:number = 0;


      volver() {
        this.http.sw.mostrarDatosclientes = false;
        this.http.sw.mostrarMenu = true;
        this.http.sw.mostrarClientes = true;
      }

      borrar(){
          this.http.datosPost.action = 2; // borrar cliente
          this.http.datosPost.datos = this.http.clienteGrabar;
          this.http.posicion(this.http.datosPost).subscribe(respuesta => {
                this.http.uploaded = respuesta;

            }, err => {

            }, () => {
                if (this.http.uploaded.Status == 1) {
                      this.toastr.success(this.http.uploaded.Text,'Clientes');
                      this.http.descargarClientes().subscribe(respuesta => {
                      this.http.sw.mostrarDatosclientes = false;
                      this.http.sw.mostrarMenu = true;
                      this.http.sw.mostrarClientes = true;
                    });
                }else{
                    this.app.showtoast();
                    this.toastr.error(this.http.uploaded.Text,'Clientes');
                }
          });
      }

      grabar() {
        this.http.datosPost.action = 1; // por defecto Update
        if (this.http.clienteGrabar.Id == 0) this.http.datosPost.action = 0; // si es nueva Insert;
          this.http.clienteGrabar.observaciones.replace(/\r?\n/g, "$");
          this.http.datosPost.datos = this.http.clienteGrabar;
          this.http.cliente(this.http.datosPost).subscribe(respuesta => {
              this.http.uploaded = respuesta;

            }, err => {
              
            }, () => {
              if (this.http.uploaded.Status == 1) {
                  this.toastr.success(this.http.uploaded.Text,'Clientes');
                  this.http.descargarClientes().subscribe(respuesta => {

                    this.http.sw.mostrarDatosclientes = false;
                    this.http.sw.mostrarMenu = true;
                    this.http.sw.mostrarClientes = true;

                  });
              }else{
                  this.toastr.error(this.http.uploaded.Text,'Clientes');
              }
        });

      }




}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/datoscclientes/datoscclientes.component.ts